<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="aboutContent">
        <div class="aboutUs">
          <div class="share sh_first">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>关于我们</h2></div>
            <span></span>
          </div>  
          <div class="view-tip">
            <div class="detail de_first">
              <p>上海功存智能科技有限公司(简称:功存智能)成立于2017年,注册资金5000万,是一家集软件研发、软件测试、业务咨询、人力外包为一体的IT综合服务企业,公司现设有软件
                效能、人力服务、智慧城市、数字孪生、系统集成五大业务部门,目前正在北京、深圳、南京、沈阳布局功存生态合作伙伴。现有员工200余名,本科硕士学位占比80%以上。自成立以来一直专注于泛金融、公安、政务、钢铁、能源、汽车、航空等行业领域,致力于成为企业最具价值的数字化转型供应商。</p>
            </div>
            <div class="detail">
              <p>截至2020年底,功存智能取得了企业信用等级3A、业务连续性管理体系、软件企业认证、高新技术企业认证、IS09001、IS027001、IS045001、IS014001、CMMI3、TMMi等资质，
                同时拥有TMMi基金会的认证服务授权和TMMi专业培训服务授权。</p>
            </div>
            <div class="detail">
              <span>自成立以来，功存智能一直致力于：</span>              
              <ul style="margin-bottom:24px">
                <li>大数据应用及数据资产治理相关的企业数字化及智慧化转型；</li>
                <li>软件设计、研发、测试、运维全生命周期的效能提升咨询解决方案、体系建设和落地工具，包括CMMI认证、TMMi认证、敏捷转型及DevOps一体化工具等；</li>
                <li>基于大数据、人工智能、区块链、云服务等先进技术在金融、公安、钢铁、能源、汽车、航空等传统业务领域的应用创新及能力升级；</li>
                <li>涵盖咨询、产品设计、项目管理、开发工程师、测试工程师等的人力外包服务；</li>
                <li>基于自有知识产权图像引擎的数字孪生业务应用建设。</li>
              </ul>
              <span>经过多年的潜心经营，功存智能在众多行业中积累了大量典型客户案例：</span>
              <ul>
                <li>泛金融行业：上海浦东发展银行、中国大地保险、安信证券等；</li>
                <li>政务行业：上海市公安局、上海市水务局等；</li>
                <li>航空运输行业：上海机场集团等；</li>
                <li>能源行业：中国宝武钢铁集团、中国林业集团等；</li>
                <li>汽车行业：上海汽车集团等</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="corporateCulture">
          <div class="share">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>企业文化</h2></div>
            <span></span>
          </div>  
          <div class="view-tip">
            <div class="brand_logo"></div>
            <div class="content">
              <div class="head">
                <span>企业文化</span>
                <p>CORPORAE   &nbsp;&nbsp;&nbsp;&nbsp;CULTURE</p>
              </div>
              <div class="detail">
                <p>我们的愿景：赋能数字时代，实现价值共赢<br>我们的使命：助力企业数字化转型，构建更具前瞻性业务模式</p>
              </div>
            </div>
          </div>
        </div>

        <div class="developmentHistory">
          <div class="share">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>发展历程</h2></div>
            <span></span>
          </div> 
          <div class="view-tip content">
            <div class="detail  firstAnm">
              <span>2020</span>
              <p>4月参与一网统管公安建设项目；7月获得TMMi培训咨询认证服务授权；<br>8月获得CMMI3级证书；11月与宝武智维签订战略合作协议 。</p>
            </div>
            <div class="detail secondAnm ">
              <span>2019</span>
              <p>9月瀛洲智眼产品，崇明一标六实（二期项目）；<br>10月宝武智巡平台，一网统管项目。</p>
            </div>
            <div class="detail thirdAnm">
              <span>2018</span>
              <p>8月魅力静安项目  智巡智维产品；10月疑犯追踪可视化产品 ，进博会社会面态势项目；<br>12月崇明一标六实（一期）项目，上海新一代指挥中心常态屏。</p>
            </div>
            <div class="detail lastAnm" >
              <span>2017</span>
              <p>8月功存智能成立；<br>11月可视化渲染引擎，AI结构化产品。</p>
            </div>
          </div>
        </div>

        <div class="honor">
          <div class="share">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>荣誉资质</h2></div>
            <span></span>
          </div> 
          <div class="view-tip">
            <div class="top">
              <div><img src="../../public/aboutusImg/honor1.png" alt=""><p>多项软件著作资质</p></div>
              <div><img src="../../public/aboutusImg/honor2.png" alt=""><p>多项专利证书</p></div>             
            </div>
            <div class="bottom">
               <el-carousel indicator-position="outside" arrow="never" :interval="5000" height="552px" style="width:1200px;overflow: hidden;">
                  <el-carousel-item >
                    <img src="../../public/aboutusImg/honor12.png" alt="">
                    <img src="../../public/aboutusImg/honor13.png" alt="">
                    <img src="../../public/aboutusImg/honor8.png" alt="">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../../public/aboutusImg/honor3.png" alt="">
                    <img src="../../public/aboutusImg/honor6.png" alt="">
                    <img src="../../public/aboutusImg/honor7.png" alt="">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../../public/aboutusImg/honor9.png" alt="">
                    <img src="../../public/aboutusImg/honor10.png" alt="">
                    <img src="../../public/aboutusImg/honor11.png" alt="">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../../public/aboutusImg/honor5.png" alt="">
                  </el-carousel-item>
                </el-carousel>             
            </div>
          </div>
        </div>
      </div>
    </el-main>

    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>
<script>
import navmenu from '../components/navmenu.vue';
import footerMenu from '../components/footer.vue';

export default {
	components: { navmenu,footerMenu },
  name: 'Home',
  data() {
    return {
      imgList: [
        {
          name: "banner1",
          title:'关于我们',
          detail:'About us',
          src: require("../../public/aboutusImg/aboutbanner.png"),
        },
      ],
      activeIndex: '7',
      activeName:'',
    };
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll,true)  
    
  },
  // 离开页面清除（移除）滚轮滚动事件
  destroyed:function () {
    window.removeEventListener('scroll', this.handleScroll);   
  },
  methods:{
    handleScroll(e){
      var eleScrollTop = document.documentElement.scrollTop;
      // console.log(eleScrollTop)
      var firstAnm = document.getElementsByClassName('firstAnm')
      var secondAnm = document.getElementsByClassName('secondAnm')
      var thirdAnm = document.getElementsByClassName('thirdAnm')
      var lastAnm = document.getElementsByClassName('lastAnm')
      if(eleScrollTop >= 1700 && eleScrollTop <= 1800){
        firstAnm[0].classList.add('right_20')
      }else if(eleScrollTop >= 1800 && eleScrollTop <= 1900){
        secondAnm[0].classList.add('left')
      }else if(eleScrollTop >= 1900 && eleScrollTop <= 2000){
        thirdAnm[0].classList.add('right_20')
      }else if(eleScrollTop >= 2300){
        lastAnm[0].classList.add('left')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/elementUi.scss'; 
@import '~@/assets/style/public.scss'; 

.share{
  padding:40px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}
.sh_first{padding:60px 0 40px 0;}

.view-tip{
  width: 1200px;   
  margin: 0 auto;
  margin-bottom: 90px;
  text-align: left;
  .title{
    height: 33px;
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 10px;
    padding-left: 10px;
    border-left: solid 3px #1E8DD4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre !important;
  }
  .detail{
    margin-top: 20px;
    text-align: left;
    font-size: 16px;
    line-height: 32px;
    color: #333;
    // padding-left: 13px;
    p{
      margin-top:-3px
    }
    span{
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      margin-bottom: 10px;
    }
    ul{
      list-style-type: disc;
      margin-left: 18px;
      li{
        // padding-bottom: 20px;
        // width: 326px;
      }
    }
  }
  .de_first{
    margin-top: 0px;
  }
}

  .el-main{
    .pic_item {
      position: relative;
      height: 100%;
      h3{
        position: absolute;
        width: 1200px;
        left: 50%;
        transform: translateX(-50%);
        text-align: left;
        top: 132px;        
        font-size: 60px;
        font-family: PingFang SC;
        font-weight: 800;
        line-height: 100px;
        color: #FFFFFF;
        opacity: 1;
        animation:moveh3 3s infinite;
        // animation-iteration-count:1;
        @keyframes moveh3{
          from {left:60%;opacity: 0;}
          to {left:50%;opacity: 1;}
        }
        @-webkit-keyframes moveh3 /*Safari and Chrome*/{
          from {left:60%;opacity: 0;}
          to {left:50%;opacity: 1;}
        }
      }      
      p{
        position: absolute;
        width: 1200px;
        left: 50%;
        transform: translateX(-50%);
        text-align: left;
        top: 242px;        
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 100px;
        color: #FFFFFF;
        opacity: 1;
        animation:movep 3s infinite;
        // animation-iteration-count:2;
        @keyframes movep{
          from {top: 282px;opacity: 0;}
          to {top: 242px;opacity: 1;}
        }
        @-webkit-keyframes movep /*Safari and Chrome*/{
          from {top: 282px;opacity: 0;}
          to {top: 242px;opacity: 1;}
        }
      }      
      span{
        display: inline-block;
        width: 44px;
        height: 10px;
        position: absolute;
        left: 231px;
        top: 172px;
        background: #fff;
        animation:movespan 3s infinite;
        @keyframes movespan{
          from {width: 0px;opacity: 0;}
          to {width: 44px;opacity: 1;}
        }
        @-webkit-keyframes movespan /*Safari and Chrome*/{
          from {width: 0px;opacity: 0;}
          to {width: 44px;opacity: 1;}
        }
      }
    }
    .pic_item:hover{
      cursor: pointer;
    }
  }

.aboutContent{
  height: 3900px;
  .aboutUs{
    height: 901px;
  }
  .corporateCulture{
    height: 532px;
    background: url(../../public/aboutusImg/logo.png) center 185px no-repeat;
    background-color: #F1F1F1;
    .view-tip{
      .brand_logo{
        height: 191.5px;
        width: 174px;
        margin-top: -90px;
        background: url(../../public/aboutusImg/bj1.png) no-repeat;
      }
      .content{
        width: 657px;
        height: 249px;
        margin-left: 600px;
        margin-top: -90px;
        background-color: #fff;
        opacity: 0.8;
        .head{
          padding-top: 34px;
          margin-left: 60px;
          font-size: 12px;
          span{
            font-size: 20px;
            font-weight: bold;
            padding-bottom: 12px;
            border-bottom: 2px solid #ccc;
          }
          p{
            padding-top: 14px;
          }          
        }
        .detail{
          margin-left: 60px;
          color: #666;
        }
      }
    }
    
  }
  .developmentHistory{
    height: 1190px;
    background-image: url(../../public/aboutusImg/bj2.png);
    .content{
      height: 944px;
      background: url(../../public/aboutusImg/bj3.png) center no-repeat ;
      position: relative;
      .detail{
        height: 127px;
        width: 621px;
        text-align: left;
        span{
          font-size: 38px;
          margin-bottom: 20px;
        }
        p{
          font-size: 16px;
          line-height: 32px;
        }
      }
      .firstAnm{
        margin-left: 640px;
        position: absolute;
        top:10%;
        display: none;
      }
      .secondAnm{
        display: none;
        position: absolute;
        top:24%
      }
      .thirdAnm{
        margin-left: 640px;
        position: absolute;
        top:52%;
        display: none;
      }
      .lastAnm{
        display: none;
        position: absolute;
        top:70%
      }
      .right_20{
        display: block;
        margin-left: 640px;
        animation:moveright 1s infinite;
        animation-iteration-count:1;
        @keyframes moveright{
          from {left:30%;opacity: 0;}
          to {left:1%;opacity: 1;}
        }
        @-webkit-keyframes moveright /*Safari and Chrome*/{
          from {left:30%;opacity: 0;}
          to {left:1%;opacity: 1;}
        }
      }
      .left{
        display: block;
        text-align: right;
        padding-top: 40px;
        position: absolute;
        right: 54%;
        animation:moveleft 1s infinite;
        animation-iteration-count:1;
        @keyframes moveleft{
          from {right:90%;opacity: 0;}
          to {right:54%;opacity: 1;}
        }
        @-webkit-keyframes moveleft /*Safari and Chrome*/{
          from {right:19%;opacity: 0;}
          to {right:3%;opacity: 1;}
        }
      }
    }
  }
  .honor{
    .top{
      display: flex;
      justify-content: space-around;
      margin-bottom: 10px;
      p{
        text-align: center;
      }
    }
    .bottom{
      display: flex;
      justify-content: space-around;
      img{
        width: 396px;
        height: 552px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/aboutus.vue